export default (score) => {
  score = parseInt(score || 0)
  if (score >= 10000000000) {
    score = '999.99M+'
  } else if (score >= 10000000) {
    score = parseInt(score / 100000) / 100 + 'M'
  } else if (score >= 10000) {
    score = parseInt(score / 100) / 100 + 'K'
  } else{
    score = score/10
  }
  return score
}


// WEBPACK FOOTER //
// src/helper/score2.js